import { useIntl } from 'react-intl'
import { titleCaps } from 'utils/universal'

export const getSEOTitle = (titleSection) => {
  const { formatMessage: f } = useIntl()
  let formattedTitle
  switch (titleSection) {
    case f({ id: 'ROUTE_QUOTE_CAR_STEP_VERSION' }):
      formattedTitle = f({ id: 'QUOTE_CAR_STEP_VERSION' })
      break
    case f({ id: 'ROUTE_QUOTE_CAR_STEP_INFORMATION' }):
      formattedTitle = f({ id: 'QUOTE_CAR_STEP_INFORMATION' })
      break
    case f({ id: 'ROUTE_QUOTE_CAR_STEP_SCHEDULE_INSPECTION_VARIANT' }):
      formattedTitle = f({ id: 'ROUTE_QUOTE_CAR_STEP_SCHEDULE_INSPECTION_VARIANT' })
      break
    case f({ id: 'ROUTE_QUOTE_CAR_STEP_SCHEDULE_CONFIRMATION' }):
      formattedTitle = f({ id: 'QUOTE_CAR_STEP_SCHEDULE_CONFIRMATION' })
      break
    default:
      formattedTitle = titleSection
  }

  return titleCaps(formattedTitle)
}

// export const addHomeIfExist = (locations) => {
//   if (!locations) {
//     return []
//   }
//   const homeObj = {
//     branch_id: 1000,
//     name: 'A Domicilio',
//   }
//   return [homeObj, ...locations.branches]
// }
